export const parseUsernames = (text: string): string[] =>
  text
    .split(/[\n,;]/)
    .map((username) => username.trim())
    .filter((username) => username.length > 0);
